import { NOTES_LIST } from '../../constants';

const initialState = {
  data: [],
  loading: true,
  error: {}
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case NOTES_LIST.LOAD:
      return {
        ...state,
        loading: true
      };
    case NOTES_LIST.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false
      };
    case NOTES_LIST.FAIL:
      return {
        ...state,
        error: payload,
        loading: false
      };
    default:
      return state;
  }
}
